import { SetLaborTypesMutation } from "~/gql/mutations/siteLocation.generated";
import {
	GetLaborActiveRatesQuery,
	GetLocationOverheadRatesQuery
} from "~/gql/queries/produce/productionCost.generated";

export const siteCostEndpoints = {
	GetLaborActiveRates: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetLaborActiveRatesQuery) => res
	},
	GetLocationOverheadRates: {
		providesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: GetLocationOverheadRatesQuery) => res
	},
	SetLaborTypes: {
		invalidatesTags: ["SiteLocation"] as AddTagTypes,
		transformResponse: (res: SetLaborTypesMutation) => res
	}
};
